(() => {
  const setActiveContent = (section, activeId) => {
    const contents = section.querySelectorAll(".chw-tab_content");

    contents.forEach((content) => {
      content.classList.remove("chw-tab_content--active", "animate");
      content.hidden = true;
    });

    const activeContent =
      section.querySelector(
        `[data-content-tab-id="${activeId}"].chw-tab_content`
      ) || section.querySelector(activeId + ".chw-tab_content");

    if (activeContent) {
      activeContent.classList.add("chw-tab_content--active");
      activeContent.hidden = false;

      // preserve your fade-in animation
      setTimeout(() => {
        activeContent.classList.add("animate");
      }, 500);

      // Set height of an annotated feature item
      const deviceWidth =
        document.documentElement.clientWidth || window.innerWidth;

      if (deviceWidth <= 990) {
        let activeFeatureEl = activeContent.querySelector(
          ".annotated-features__item-inner.active"
        );

        if (activeFeatureEl) {
          let parentEl = activeFeatureEl.parentElement;
          let activeElHeight =
            activeFeatureEl.getBoundingClientRect().height + 30;
          parentEl.setAttribute("data-height", activeElHeight + "px");
          parentEl.style.height = `${activeElHeight}px`;
        }
      }
    }
  };

  const toggleTabs = (section) => {
    const tabs = section.querySelectorAll(".chw-tab_link");

    const activateTab = (tab) => {
      // deactivate all tabs
      tabs.forEach((el) => {
        el.classList.remove("active");
        el.setAttribute("aria-selected", "false");
      });

      // activate current tab
      tab.classList.add("active");
      tab.setAttribute("aria-selected", "true");

      // update content
      const id = tab.dataset.contentTabId;
      setActiveContent(section, id);

      tab.focus();
    };

    tabs.forEach((tab) => {
      tab.addEventListener("click", (e) => {
        e.preventDefault();
        if (!tab.classList.contains("active")) {
          activateTab(tab);
        }
      });

      tab.addEventListener("keydown", (e) => {
        const currentIndex = Array.from(tabs).indexOf(tab);
        let newIndex = null;

        switch (e.key) {
          case "Enter":
          case " ":
            e.preventDefault();
            if (!tab.classList.contains("active")) activateTab(tab);
            break;

          case "ArrowRight":
            newIndex = (currentIndex + 1) % tabs.length;
            break;

          case "ArrowLeft":
            newIndex = (currentIndex - 1 + tabs.length) % tabs.length;
            break;

          case "Home":
            newIndex = 0;
            break;

          case "End":
            newIndex = tabs.length - 1;
            break;

          default:
            return;
        }

        if (newIndex !== null) {
          e.preventDefault();
          tabs[newIndex].focus();
        }
      });
    });
  };

  const chwTabsGroup = document.querySelector(".chw-tabs_group");
  if (chwTabsGroup) toggleTabs(chwTabsGroup);
})();
